import { Form, Typography } from 'antd'
import React, { useCallback, useEffect, useMemo, useState } from 'react'
import { ToolExcludeScanReportAPI } from 'restAPI/ToolsIntegrationAPI'
import { FieldTypes, generateFormFields, parseSelectOptions } from 'utils/formUtils'
import { useGlobalFilterContext } from 'contexts/GlobalFilterContext';
import { EXCLUDE_WORK_FLOW_TOOL_NAME } from './SettingStatusConstant'

const ExcludeScanReport = ({ toolName, handleExcludeScanReport }) => {
    const apiToolName = EXCLUDE_WORK_FLOW_TOOL_NAME[toolName];
    const [toolWorkFlows, setToolWorkFlows] = useState();
    const [form] = Form.useForm();
    const { globalFilterHash } = useGlobalFilterContext();

    const fetchWorkFlowsData = useCallback(() => {
        const { promise , cancel} = ToolExcludeScanReportAPI.getWorkFlow(apiToolName);

        promise.then(setToolWorkFlows);

        return cancel;
    }, [apiToolName])


    const fetchData = useCallback(() => {
        const { promise, cancel } = ToolExcludeScanReportAPI.getExcludedWorkFlows(apiToolName);

        promise.then(excludedWorkFlows => {
            form.setFieldsValue({ workflows: excludedWorkFlows })
            handleExcludeScanReport(excludedWorkFlows); 
        })

        return cancel;
    }, [apiToolName, form, handleExcludeScanReport])

    useEffect(() => {
        fetchWorkFlowsData();
    }, [globalFilterHash, fetchWorkFlowsData])

    useEffect(() => {
        fetchData();
    }, [globalFilterHash, fetchData])


    const fields = useMemo(() => [{
        name: "workflows",
        label: <Typography.Text>Exclude scan reports from the following {toolName} workflows</Typography.Text>,
        placeholder: <Typography.Text>Select {toolName} workflows</Typography.Text>,
        type: FieldTypes.MULTI_SELECT,
        options: parseSelectOptions(toolWorkFlows),
        colSpan: 18,
        props: {
            allowClear: true
        }
    }], [toolName, toolWorkFlows])


    return (
        <Form
            form={form}
            layout="vertical"
            onValuesChange={(values) => {
                handleExcludeScanReport(values.workflows)
            }}
        >
            {generateFormFields(fields)}
        </Form>

    )
}

export default ExcludeScanReport;
